import request from "@/utils/request";

let DataApi = {
  /*用户接口*/
  getUser(data, errorback) {
    return request._postBody("/shop/data/user/list", data, errorback);
  },
  /*用户接口*/
  getRegion(data, errorback) {
    return request._post('/shop/data/region/list', data, errorback);
  },
  /*地区接口*/
  getLakalaRegion(data, errorback) {
    return request._post('/shop/data/region/lakala/list', data, errorback);
  },
  /*查询银行列表*/
  getBanking(data, errorback) {
    return request._post('/shop/data/bank/list', data, errorback);
  },
  /*获取对私银行卡号开户银行*/
  getBanksByBankAccount(data, errorback) {
    return request._get('/shop/data/bank/search-banks-by-bank-account', data, errorback);
  },
  /*获取对私银行卡号开户银行*/
  cardBin(data, errorback) {
    return request._get('/shop/data/bank/cardBin', data, errorback);
  },
  /*用户接口*/
  getIndustryRules(data, errorback) {
    return request._post('/shop/data/industryRule/list', data, errorback);
  },
  /*图片上传*/
  imageUploadV3(data, errorback) {
    return request._upload('/shop/data/bank/media-upload', data, errorback);
  },
};
export default DataApi;



// WEBPACK FOOTER //
// ./src/api/data.js